import React from 'react';

/**
 * Replaces the current URL with a static HTML file under /public/.
 *
 * The canonical Terms & Conditions content lives at /terms.html (built from
 * LuzuPoints_Terms_and_Conditions.docx). React routes /privacy, /policy and
 * /terms all funnel through these redirects so there is one source of truth.
 */
export const RedirectToStatic: React.FC<{ to: string }> = ({ to }) => {
  React.useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};
